import React, { useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 * Ben Bud: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
 */
export default function useOutsideClick(ref, setHighlightCell) {
  useEffect(() => {
    /**
     * Trigger event if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setHighlightCell([]);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
